import { useTranslation } from 'react-i18next';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { FlexRow } from 'src/components/layout/flex-row';
import { ButtonV2 } from '../button/lgg-button';

const FilterActionButton = styled(ButtonV2)`
  font-size: 12px;
  font-size: 14px;
  height: 38px;
  line-height: 18px;
  padding: 10px;
  width: 100%;

  ${up('md')} {
    font-size: 12px;
    height: 32px;
    padding: 7px 15px;
    width: unset;
  }

  & + & {
    margin-left: 15px;
  }
`;

const FilterActionButtonsContainer = styled(FlexRow)`
  border-top: 1px solid ${({ theme }) => theme.colors.koala};
  justify-content: flex-end;
  margin-top: 15px;
  padding: 15px 20px;

  ${up('md')} {
    border: none;
    padding: 0;
  }
`;

type OverlayFilterActionButtonsProps = {
  onReset: React.MouseEventHandler<HTMLButtonElement>;
  onSubmit?: React.MouseEventHandler<HTMLButtonElement>;
  baseTestId?: string;
};

export const OverlayFilterActionButtons = ({
  onReset,
  onSubmit,
  baseTestId,
}: OverlayFilterActionButtonsProps) => {
  const { t } = useTranslation(['common']);

  return (
    <FilterActionButtonsContainer>
      <FilterActionButton
        variant="default"
        size="small"
        type="button"
        onClick={onReset}
        data-lgg-id={`${baseTestId}-reset-button`}
      >
        {t('common:filters.actionReset')}
      </FilterActionButton>
      <FilterActionButton
        variant="primary"
        type="submit"
        size="small"
        onClick={onSubmit}
        data-lgg-id={`${baseTestId}-apply-button`}
      >
        {t('common:filters.actionsApply')}
      </FilterActionButton>
    </FilterActionButtonsContainer>
  );
};
